module.exports = __webpack_public_path__ + "img/title-img.218ec0dc.png";